import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';

import { AuthService } from 'src/app/auth.service';
import { ForceChangePasswordModalComponent } from 'src/app/auth/components/force-change-password-modal/force-change-password-modal.component';

@Injectable({ providedIn: 'root' })
export class ForcePasswordChangeService {
  private modalRef?: NgbModalRef;

  constructor(
    private modalService: NgbModal,
    private cookieService: CookieService,
    private authService: AuthService
  ) { }

  /**
   * Abre el modal bloqueante de cambio de contraseña obligatorio. Si ya está
   * abierto (p. ej. varios 403 concurrentes), devuelve la misma promesa en
   * vez de abrir un segundo modal.
   */
  open(): Promise<void> {
    if (this.modalRef) {
      return this.modalRef.result.then(
        () => undefined,
        () => undefined
      );
    }

    const token = this.cookieService.get('gr_access');
    const decoded = token ? this.authService.getDecodedAccessToken(token) : null;
    const userId = decoded?.user_id;

    if (!userId) {
      console.error('ForcePasswordChangeService: no se pudo obtener el userId del token de acceso');
      return Promise.resolve();
    }

    this.modalRef = this.modalService.open(ForceChangePasswordModalComponent, {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      windowClass: 'force-password-change-modal-window',
    });
    this.modalRef.componentInstance.userId = userId;

    return this.modalRef.result.then(
      () => { this.modalRef = undefined; },
      () => { this.modalRef = undefined; }
    );
  }
}
